// import router, {resetRouter} from "/src/router"

import router from "@/router";

const state = ()=>({
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
  // token: "7ea5c70a-802e-40b9-9a77-ebc86ac5daae",
  user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{}
})

const mutations = {
  setToken: (state, token)=>{
    state.token = token
    localStorage.setItem("token", token)
  },
  setUserInfo: (state, user)=>{
    state.user = user
    localStorage.setItem("user", JSON.stringify(user))
  },
  logout: (state)=> {
    state.token = ""
    // state.member = {}
    sessionStorage.clear()
    localStorage.clear()
    // localStorage.clear()
    // resetRouter()
  }
}

const actions = {
  asyncLogout({commit}, location){
    commit("permission/setButtons", [], { root: true })
    commit("permission/setMenus", [], { root: true })
    commit("permission/setRouters", [], { root: true })
    commit("logout")
    console.log(1231231)
    router.push({
      path: "/login"
    }).then(r => {})
  }

}

export default {
  state,
  mutations,
  actions,
  namespaced: true,
}

